// extracted by mini-css-extract-plugin
export default {"round":"ActualRoundNo_round__g0b5n","show":"ActualRoundNo_show__CZycI"};